export const SEND_ANSWERS = "[Answers] Send data";
export const UPDATE_ANSWERS = "[Answers] Update Answers";
